import { callGet, callPost, callDelete, callPut } from "../integrations/calls";
import { REQ } from "../../libs/constants";

export const getVoucher = async (data, token) => {
  return await callPost(REQ.BULK_PURCHASE.GET_VOUCHER, data, token);
};

export const saveData = async (data, token) => {
  return await callPost(REQ.BULK_PURCHASE.SAVE_DATA, data, token);
};

export const getData = async (id, token) => {
  return await callGet(`${REQ.BULK_PURCHASE.GET_DATA}/${id}`, token);
};

export const updatePurchase = async (data, token) => {
  return await callPut(
    `${REQ.BULK_PURCHASE.UPDATE_PURCHASE}/${data.id}`,
    data,
    token
  );
};

export const deleteInvoivce = async (id, token) => {
  return await callDelete(
    `${REQ.BULK_PURCHASE.DELETE_INVOICE}/${id}`,
    {},
    token
  );
};
